import React,{useEffect} from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert';


const PaymentStatus = () => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const remark = searchParams.get("remark");

    const executedRef = React.useRef(false);
  // console.log('params...',params)
    useEffect(()=>{
      if (executedRef.current) return; // stop re-runs
      executedRef.current = true;     // mark executed

      if(params.status === 'success'){
        swal('Congratulations Your fee submitted successfully.','','success')
        navigate('/student/dashboard');
      }
      else{
        remark ? swal(remark,'Your payment is failed please try again.','error') 
        : swal('Your payment is failed please try again.','','error')
          
          navigate('/student/dashboard');
      }
  },[])
  
  return (
    <div></div>
  )
}

export default PaymentStatus